import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaTh, FaComments, FaChalkboardTeacher, FaPowerOff } from "react-icons/fa";
import { MdLiveHelp } from "react-icons/md";
import "../../Admin/Sidebar/Sidebar.css";
import coderwinglogo from "../../Image/coderwing-logo.png";
import Dashboardlogo from "../../Image/Chatbots-logo.png";
import courseslogo from "../../Image/Courses-logo.png";
import inqurirylogo from "../../Image/Inquiry-logo.png";
import logoutlogo from "../../Image/logout-logo.png";
import logodashboard from "../../Image/logodashboard.png";
import boyimage from "../../Image/Student-Side.png";
import { Home } from "lucide-react";

const Sidebar = () => {
  const navigate = useNavigate();

  const handleLogout = async (e) => {
    e.preventDefault(); 
    
    try {
      const response = await fetch('https://coderwing2-5.onrender.com/api/auth/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (response.ok) {
       
        localStorage.removeItem('token');
        
        navigate('/');
      } else {
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className="sidebar">
      <div className="logo">
        <img src={coderwinglogo} alt="Logo" />
      </div>

      <ul className="menu">
        <li>
          <NavLink to="/StudentAdmin" activeClassName="active">
            <img src={logodashboard} alt="" className="icon" />
            <span>Dashboard</span>
          </NavLink>
        </li>
       <li>
          <NavLink to="/InquiryAdmin" activeClassName="active">
            <img src={inqurirylogo} alt="" className="icon" />
            <span>Inquiry</span>
          </NavLink>
        </li>
     
        <li>
          <NavLink to="/coursesAdmin" activeClassName="active">
            <img src={courseslogo} alt="" className="icon" />
            <span>Courses</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/" activeClassName="active">
            <div className="icon"><Home /></div>
            <span>Home</span>
          </NavLink>
        </li>
        <li className="logout">
          <a href="/" onClick={handleLogout}>
            <img src={logoutlogo} alt="" className="icon" />
            <span>Logout</span>
          </a>
        </li>
      </ul>

      <div className="premium-card">
        <img
          src={boyimage}
          alt="Premium Offer"
          className="card-image"
        />
        {/* <div className="card-content">
          <h2 className="h2-text">Get Premium Now!</h2>
          <p>Explore our new features by subscribing our package</p>
          <button className="subscribe-btn">Subscribe</button>
        </div> */}
      </div>
    </div>
  );
};

export default Sidebar;
